import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { internalMessageBus } from "sb-internal-msg-bus";
import { BaseDict } from "./dict";
import { config } from "./config";
import { Scoreboard } from "./Scoreboard";
import { ScoreboardData } from "./data";
import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
let _LOCALMOCKSTYPE;
let BaseballScoreboardDataMock;
if (process.env.NODE_ENV === "development") {
    _LOCALMOCKSTYPE = require("../../Mocks");
    BaseballScoreboardDataMock = _LOCALMOCKSTYPE.BaseballScoreboardDataMock;
}
export class ScoreboardRoot extends BaseBlock {
    constructor(domId, options = {
        //TO Do delete unused properties
        dict: BaseDict,
        cms: {},
        dataProvider: {},
        panelId: "",
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            this.dataProvider = new ScoreboardData(new Parser(new Retriever(internalMessageBus, "url(test.png)")));
            window["ScoreboardDATA"] = this.dataProvider;
            window["BaseballScoreboardDataMock"] = new BaseballScoreboardDataMock(internalMessageBus);
            window["BaseballScoreboardDataMock"].activate();
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            this.dataProvider = new ScoreboardData(new Parser(new Retriever(options.dataProvider.messageBus, options.dataProvider.backgroundImg)));
        }
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
    }
    activate() {
        this.dataProvider.activate();
        return super.activate(React.createElement(Scoreboard, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
    deactivate() {
        this.dataProvider.deactivate();
        return super.deactivate();
    }
}
window["Scoreboard"] = ScoreboardRoot;
broadcastBlockLoad("Scoreboard");
//# sourceMappingURL=index.js.map